'use strict';

const styles = theme => ({
	popover: {
		padding: theme.spacing(2),
	},
	popoverText: {
		paddingRight: theme.spacing(2),
	},
});

export default styles;